import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = logged in

  useEffect(() => {
    // Verify the admin session only on admin routes. Public pages don't need
    // an auth check, which also avoids an unnecessary /auth/me request that
    // search engine crawlers would otherwise log as an error.
    if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) {
      api
        .get("/auth/me")
        .then(({ data }) => setUser(data))
        .catch(() => setUser(false));
    } else {
      setUser(false);
    }
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setUser(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
